import type { IFieldConfig } from "../types/scad";
import {
  defaultComponentMap,
  type ComponentMapType,
  type ComponentConfig,
} from "./componentMap";
import {
  defaultControlTypeMapping,
  type ControlTypeMappingType,
} from "./controlTypeMapping";
import {
  metaColumnFieldConfig,
  getMetaColumnFieldsByGroup,
} from "./metaColumnConfig";

let componentMap: ComponentMapType = { ...defaultComponentMap };
let controlTypeMapping: ControlTypeMappingType = {
  ...defaultControlTypeMapping,
};

export function getComponentMap(): ComponentMapType {
  return componentMap;
}

export function getControlTypeMapping(): ControlTypeMappingType {
  return controlTypeMapping;
}

export function setComponentMapOverrides(
  overrides: Partial<ComponentMapType>,
): void {
  componentMap = { ...defaultComponentMap, ...overrides };
}

export function setControlTypeMappingOverrides(
  overrides: Partial<ControlTypeMappingType>,
): void {
  controlTypeMapping = {
    ...defaultControlTypeMapping,
    ...overrides,
  } as ControlTypeMappingType;
}

export { defaultComponentMap, defaultControlTypeMapping };
export type { ComponentMapType, ComponentConfig, ControlTypeMappingType };

// Meta column configuration exports
export {
  metaColumnFieldConfig,
  getMetaColumnFieldsByGroup,
  // getFieldOptions,
  // controlTypeOptions,
  // searchTypeOptions,
};
export type { IFieldConfig };
